const initialState = {
  zones: [],
  isLoading: false,
  error: null,
  userZoneAccessesLoading: false,
  userZoneAccesses: null
};

const zoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_ZONE_ACCESSES_REQUEST':
      return {
        ...state,
        userZoneAccessesLoading: true,
        userZoneAccesses: null
      };

    case 'FETCH_USER_ZONE_ACCESSES_SUCCESS':
      return {
        ...state,
        userZoneAccessesLoading: false,
        userZoneAccesses: action.payload
      };

    case 'FETCH_USER_ZONE_ACCESSES_FAILURE':
      return {
        ...state,
        userZoneAccessesLoading: false,
        userZoneAccesses: null
      };

    case 'FETCH_ZONES_REQUEST':
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case 'FETCH_ZONES_SUCCESS':
      return {
        ...state,
        zones: action.payload,
        isLoading: false,
        error: null
      };

    case 'FETCH_ZONES_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case 'ADD_ZONE_LOCAL':
      return {
        ...state,
        zones: [...state.zones, action.payload]
      };

    case 'UPDATE_ZONE_LOCAL':
      return {
        ...state,
        zones: state.zones.map(zone =>
          zone.id === action.payload.id ? action.payload : zone
        )
      };

    case 'DELETE_ZONE_LOCAL':
      return {
        ...state,
        zones: state.zones.filter(zone => zone.id !== action.payload)
      };

    case 'REPLACE_ZONE_LOCAL':
      return {
        ...state,
        zones: state.zones.map(zone =>
          zone.id === action.payload.oldId ? action.payload.newZone : zone
        )
      };

    default:
      return state;
  }
};

export default zoneReducer;

